export default "__VITE_ASSET__Bar85xqN__"